import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            name: 'home',
            component: HomeView,
            children: [
                {
                    path: 'res/:id',
                    name: 'resource-detail',
                    component: () => import('../views/ResourceDetailView.vue'),
                },
            ],
        },
        {
            path: '/admin',
            name: 'admin',
            component: () => import('../views/admin/AdminView.vue'),
        },
        {
            path: '/admin/customer/:id',
            name: 'admin-customer',
            component: () => import('../views/admin/CustomerView.vue'),
        },
        {
            path: '/admin/login',
            name: 'admin-login',
            component: () => import('../views/admin/AdminLogin.vue'),
        },
        {
            path: '/admin/search',
            name: 'admin-search',
            component: () => import('../views/admin/SearchView.vue'),
        },
        {
            path: '/admin/manuals/:topLevel?',
            name: 'admin-manuals',
            component: () => import('../views/admin/ManualUploadView.vue'),
        },
        {
            path: '/admin/edit-time',
            name: 'admin-edit-time',
            component: () => import('../views/admin/EditTimeView.vue'),
        },
        {
            path: '/admin/translation-keys',
            name: 'admin-translation-keys',
            component: () => import('../views/admin/TranslationKeysView.vue'),
        },
    ],
});

export default router;
